(() => {
  const name = 'tooltip';

  App.common = App.common || {};

  App.common[name] = (() => {
    let $tooltip = {};

    const getTooltipIcon = function ($jsTooltip) {
      const $svgIcon = $jsTooltip.is('svg') && $jsTooltip;
      const $svgInsideTooltip = $jsTooltip.find('svg[role="img"]');
      return $svgIcon || ($svgInsideTooltip.length && $svgInsideTooltip) || $jsTooltip;
    };

    const position = function ($jsTooltip) {
      const $tooltipIcon = getTooltipIcon($jsTooltip);
      const windowInnerWidth = window.innerWidth;
      const halfTooltipWidth = $tooltip.outerWidth() / 2;
      const minTooltipWidth = 120;
      const paddingFromBorder = 10;
      const coords = $tooltipIcon.offset();
      const isEnoughPlace = (windowInnerWidth - coords.left) >= halfTooltipWidth + paddingFromBorder;
      const xPosCenteredTooltip = coords.left + $tooltipIcon.width() / 2 - $tooltip.outerWidth() / 2;
      const xPos = isEnoughPlace ? xPosCenteredTooltip : windowInnerWidth - minTooltipWidth - paddingFromBorder;
      return {
        top: coords.top - $tooltip.outerHeight() - paddingFromBorder * 1.5,
        left: xPos,
      };
    };

    const hide = function () {
      $tooltip.addClass('hide');
      $(document).off('click', hide);
    };

    const iconMouseoutHandler = function (ev) {
      const $tooltipIcon = $(this);
      if (!$(ev.toElement).closest($tooltipIcon).length) {
        $tooltip.addClass('hide');
        $tooltipIcon.off('mouseout', iconMouseoutHandler);
      }
    };

    const setEventListeners = function () {
      if (App.global.isDesktop()) {
        $(document)
          .on('mouseover', '.js-tooltip', function showTooltipOnMouseOver() {
            const $tooltipIcon = $(this);
            const text = $tooltipIcon.data('text');

            if (text) {
              // Need calculate position 2 times when tooltip has no much room for it
              $tooltip
                .text(text)
                .css(position($tooltipIcon))
                .addClass('opacity0')
                .removeClass('hide')
                .css(position($tooltipIcon))
                .removeClass('opacity0');

              $tooltipIcon.on('mouseout', iconMouseoutHandler);
            }
          });
      } else {
        $(document)
          .on('touchend', '.js-tooltip', function toggleTooltipOnTouchEnd(e) {
            const $tooltipIcon = $(this);
            const text = $tooltipIcon.data('text');

            e.preventDefault();
            e.stopPropagation();

            if (text) {
              $tooltip
                .text(text)
                .css(position($tooltipIcon))
                .toggleClass('hide');

              if (!$tooltip.hasClass('hide')) {
                $(document).on('click', hide);
              } else {
                $(document).off('click', hide);
              }
            }
          });

        $(window).on('scroll orientationchange', hide);
      }
    };

    const init = () => {
      $tooltip = $('<div id="tooltip" class="hide"></div>').appendTo('body');
      setEventListeners();
    };

    return {
      init,
    };
  })();
})();
